import prependProxyToUrlIfNeeded from '../../../helpers/proxyUrlHelper';
import staticConfigFactory from '../../../helpers/StaticConfig';

const defaultStaticConfig = staticConfigFactory().onlyLocal();

// Returns URL of CDN on which ML assets are hosted
const getCdnUrl = (staticConfig, proxyUrl, library) => {
  const mlPath = 'ml-transformers/v4.0.0';
  const nsPath = 'noise-suppression/v1.0.0';
  const path = library === 'noise-suppression' ? nsPath : mlPath;
  const { apiUrl } = staticConfig;
  const isProd = apiUrl.includes('anvil.opentok.com');
  let host = isProd ? 'https://static.opentok.com' : 'https://www.dev.tokbox.com';

  if (proxyUrl) {
    if (proxyUrl.includes('euproxy.opentok.com')) {
      host = 'https://static-eu.opentok.com';
    } else {
      host = prependProxyToUrlIfNeeded(host, proxyUrl);
    }
  }

  return `${host}/${path}`;
};

// Default configuration that may be shared by all ML transforms
const DefaultConfig = {
  getConfig: (deps = {}) => {
    const {
      staticConfig = defaultStaticConfig,
      proxyUrl,
      library,
    } = deps;

    const cdnUrl = getCdnUrl(staticConfig, proxyUrl, library);

    return {
      mediapipeBaseAssetsUri: `${cdnUrl}`,
      wasmAssetUriPath: `${cdnUrl}/`,
      tfliteAssetUriPath: `${cdnUrl}/`,
      assetsDirBaseUrl: `${cdnUrl}/`,
    };
  },
};

export default DefaultConfig;
